// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RevenueResult_wrapper__zxiEc","charts":"RevenueResult_charts__bU0sT","slickDots":"RevenueResult_slickDots__PB6R8","title":"RevenueResult_title__L6DXb"};